module.exports = "/_next/static/images/ddc2a6b257692747d54134072d841555-pen@desktop1024.jpg.webp";